import { useEffect, useState } from "react";
import { Instagram, Linkedin, ArrowUpRight } from "lucide-react";
import { BRAND, waLink } from "@/data/content";

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const links = [
    { label: "Work", href: "#work" },
    { label: "Approach", href: "#approach" },
    { label: "Results", href: "#results" },
  ];

  return (
    <header
      data-testid="site-header"
      className={`fixed inset-x-0 top-0 z-50 animate-[fade-up_0.6s_2.2s_both] transition-[background-color,backdrop-filter,border-color] duration-500 ${
        scrolled
          ? "border-b border-white/10 bg-black/70 backdrop-blur-xl"
          : "border-b border-transparent bg-transparent"
      }`}
    >
      <div className="mx-auto flex max-w-[1400px] items-center justify-between px-5 py-4 sm:px-8">
        <a href="#top" data-testid="header-logo" className="flex items-center">
          <img
            src={BRAND.logo}
            alt="Growth Therapy"
            className="h-14 w-auto sm:h-16"
          />
        </a>

        <nav className="hidden items-center gap-9 md:flex">
          {links.map((l) => (
            <a
              key={l.label}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className="group relative font-mono-accent text-xs uppercase tracking-[0.2em] text-neutral-300 transition-colors hover:text-yellow-400"
            >
              {l.label}
              <span className="absolute -bottom-1 left-0 h-px w-0 bg-yellow-400 transition-[width] duration-300 group-hover:w-full" />
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href={BRAND.instagram}
            target="_blank"
            rel="noreferrer"
            data-testid="header-instagram"
            className="grid h-10 w-10 place-items-center rounded-full border border-white/15 text-neutral-300 transition-colors hover:border-yellow-400 hover:text-yellow-400"
            aria-label="Instagram"
          >
            <Instagram size={17} />
          </a>
          <a
            href={BRAND.linkedin}
            target="_blank"
            rel="noreferrer"
            data-testid="header-linkedin"
            className="grid h-10 w-10 place-items-center rounded-full border border-white/15 text-neutral-300 transition-colors hover:border-yellow-400 hover:text-yellow-400"
            aria-label="LinkedIn"
          >
            <Linkedin size={17} />
          </a>
          <a
            href={waLink()}
            target="_blank"
            rel="noreferrer"
            data-testid="header-book-button"
            className="group inline-flex items-center gap-1.5 rounded-full bg-yellow-400 px-4 py-2.5 text-sm font-semibold text-black transition-[transform,box-shadow] duration-300 hover:scale-[1.03] hover:shadow-[0_0_30px_rgba(250,204,21,0.5)]"
          >
            Book a call
            <ArrowUpRight
              size={16}
              className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
            />
          </a>
        </div>
      </div>
    </header>
  );
};
